import Vue from 'vue'
import Vuex from 'vuex'

import Auth from './modules/auth'
import Hunters from './modules/hunters'
import Providers from './modules/providers'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    Hunters,
    Providers
  }
})
